<template>
  <v-select :options="countries"
            :clearable="false"
            :searchable="true"
            label="dialCode"
            class="dial-code-select"
            :calculate-position="withPopper"
            append-to-body
            :filter="filterBy"
            v-model="selectedOption"
            @open="onOpen"
            @close="onClose"
  >
    <template #option="{ code, dialCode }">
      <div class="dial-code-select__option">
        <span class="dial-code-select__value"
              :style="`font-family: ${colors.font}`"
        >
          {{ `${code} (${dialCode})` }}
        </span>
      </div>
    </template>

    <template #selected-option="{ dialCode }">
      <div class="dial-code-select__selected-option">
        <span class="dial-code-select__value"
              :style="`font-family: ${colors.font}`"
        >
          {{ dialCode }}
        </span>
      </div>
    </template>

    <template #open-indicator>
      <img :src="caretIcon"
           alt="toggle dropdown"
           height="5"
           :style="`transform: rotate(${isOpen ? 180 : 0}deg); transition: .3s ease-in-out;`"
      />
    </template>

    <template #no-options="{ search }">
      <div class="dial-code-select__no-options" :style="`font-family: ${colors.font}`">{{ $t('error.dialCodeNoOptions', {term: search}) }}</div>
    </template>
  </v-select>
</template>

<script>
import 'vue-select/dist/vue-select.css'
import vSelect from 'vue-select'
import getCountries from '@/util/countries'
import caretIcon from '@/assets/caret-icon.svg'
import { createPopper } from '@popperjs/core'
import sanitizeString from 'replace-special-characters'

export default {
  name: 'DialCodeSelect',

  components: {
    vSelect
  },

  props: {
    colors: {
      type: Object,
      required: true
    },
    value: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      caretIcon,
      isOpen: false,
      dropdown: null,
      dropdownWidths: {
        noOptions: '180px',
        options: '130px'
      }
    }
  },

  computed: {
    selectedOption: {
      get () {
        return this.countries.find(({ code }) => code === this.value)
      },
      set (country) {
        this.$emit('input', country.code)
      }
    },

    countries () {
      return getCountries()
    }
  },

  methods: {
    withPopper (dropdownList, component) {
      dropdownList.style.width = this.dropdownWidths.options
      dropdownList.id = 'dial-code-select-dropdown'
      this.dropdown = dropdownList
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: 'top-start',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -1]
            }
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn ({ state }) {
              component.$el.classList.toggle(
                'drop-up',
                state.placement === 'top'
              )
            }
          }
        ]
      })

      return () => popper.destroy()
    },

    filterBy (options, searchQuery) {
      if (!searchQuery) return options

      const term = sanitizeString(searchQuery.toLowerCase())
      const filtered = options.filter(item => {
        const name = sanitizeString(item.name.toLowerCase())
        return name.includes(term) || item.dialCode.includes(term) || item.code.toLowerCase().includes(term)
      })
      this.setDropdownWidth(filtered.length)

      return filtered
    },

    setDropdownWidth (optionsCount) {
      if (!optionsCount) {
        this.dropdown.style.width = this.dropdownWidths.noOptions
      }

      if (!!optionsCount && this.dropdown.style.width === this.dropdownWidths.noOptions) {
        this.dropdown.style.width = this.dropdownWidths.options
      }
    },

    onOpen () {
      this.$emit('open')
      this.isOpen = true
    },

    onClose () {
      this.$emit('close')
      this.isOpen = false
    }
  }
}
</script>
